<div #wrapper class="breakdowns-wrapper row">
    <div *ngFor="let breakdown of breakdowns"
         [ngClass]="horizontal ? 'col-3 breakdown' : 'col-12 breakdown'">
        <img [src]="breakdown.image"/>
        <div class="breakdown-description">{{ breakdown.nutrients }} {{ breakdown.description }}</div>
    </div>
</div>
